export default __webpack_public_path__ + "static/media/anomaly-value-icon.57581eb8.svg";